import {Debugger} from "debug";
import {IController, IModule} from "angular";
import _ from "lodash";

const debug: Debugger = require('debug')('KortsamlingKontroller');

export class KortsamlingKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmKortsamling', {
                bindings: {gruppeId: '<'},
                controller: KortsamlingKontroller.forInjisering(),
                template: '<div class="kortsamling"><div ng-transclude></div></div>',
                transclude: true,
            });
    }

    static forInjisering() {
        return [KortsamlingKontroller];
    }

    constructor() {
    }

    private kort: KortISamling[] = [];

    kortMedFokus: KortISamling = null;

    registrerOgWrap(kontroller: any): KortISamling {
        return new KortISamlingImpl(kontroller, this);
    }

    registrer(kort: KortISamling) {
        this.kort.push(kort);
    }

    fokuser(kort: KortISamling) {
        this.kortMedFokus = kort;
        _(this.kort).filter(k => k !== kort).each(k => {
            k.kallVedFokusMistet();
        })
    }

    slippFokus() {
        this.kortMedFokus = null;
    }

    $onInit(): void {
    }
}

export interface KortISamling {
    fokuser(): void;

    slippFokus(): void;

    harFokus(): boolean;

    annetKortHarFokus(): boolean;

    vedFokusMistet(kall: () => void): KortISamling;

    kallVedFokusMistet(): void;
}

export class KortISamlingImpl implements KortISamling {

    constructor(private kontroller: any, private kortsamlingKontroller: KortsamlingKontroller) {
        this.kortsamlingKontroller.registrer(this);
    }

    private _kallVedFokusMistet: Function[] = [];

    vedFokusMistet(kall: Function): KortISamling {
        this._kallVedFokusMistet.push(kall);
        return this;
    }

    kallVedFokusMistet() {
        _(this._kallVedFokusMistet).each(k => {
            k();
        });
    }

    annetKortHarFokus(): boolean {
        return !_.isNil(this.kortsamlingKontroller.kortMedFokus) && this.kortsamlingKontroller.kortMedFokus !== this;
    }

    fokuser(): void {
        this.kortsamlingKontroller.fokuser(this);
    }

    harFokus(): boolean {
        return !_.isNil(this.kortsamlingKontroller.kortMedFokus) && this.kortsamlingKontroller.kortMedFokus === this;
    }

    slippFokus(): void {
        this.kortsamlingKontroller.slippFokus();
    }
}